import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {mdDownN} from '../ui/common/breakpoints'
import BuildNumber from '../assets/build.number';

const BottomFixedFontStyle = styled.div`
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 13px;
    color: white;
    display: flex;
    position: absolute;
    left: 152px;
    width: 333px;
    top: 3px;
`

const BottomFixedStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    height: 20px;
    width: 1440px;
    bottom: 0px;
    background-color: #14284B;
    z-index: 100;
    @media (max-width: 1400px){
        width: 100vw;
    }
    ${mdDownN`
        width: 100vw;
        height: unset;
        flex-direction: column;
        justify-content: center;
        // position:fixed;
    `}
`;

const AppVersion = (props) => {
    const [versionNumber, setVersionNumber] = useState("")

    useEffect(() => {
        fetch(BuildNumber)
            .then(response => response.text())
            .then(data => {
                setVersionNumber("v " +data)
            })
    }, []);

    return (
        <BottomFixedStyle>
            <BottomFixedFontStyle>{versionNumber}</BottomFixedFontStyle>
        </BottomFixedStyle>
    );
}

export default AppVersion